import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CACHE_KEYS } from "../../services/local/CacheManager";
import { Store } from "../../entity/Store";

interface StoreState {
  store: Store | null;
}

const initialState: StoreState = {
  store: null,
};

const storeSlice = createSlice({
  name: "store",
  initialState,
  reducers: {
    setStore: (state, action: PayloadAction<Store | null>) => {
      state.store = action.payload;
      if (action.payload) {
        localStorage.setItem(CACHE_KEYS.STORE, JSON.stringify(action.payload));
      } else {
        localStorage.removeItem(CACHE_KEYS.STORE);
      }
    },
    clearStore: (state) => {
      state.store = null;
      localStorage.removeItem(CACHE_KEYS.STORE);
    },
  },
});

export const { setStore, clearStore } = storeSlice.actions;
export default storeSlice.reducer;
